export const SMART_LAUNCH_PATH = `launch`;
